module.exports = __webpack_public_path__ + "media/images/fb_signin-349b370a228742c635a89e0d917dc8b6.png";